import { render, staticRenderFns } from "./GiveDiscount.vue?vue&type=template&id=0d247ef8&scoped=true"
import script from "./GiveDiscount.vue?vue&type=script&lang=js"
export * from "./GiveDiscount.vue?vue&type=script&lang=js"
import style0 from "./GiveDiscount.vue?vue&type=style&index=0&id=0d247ef8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d247ef8",
  null
  
)

export default component.exports